export enum GenPdpTabs {
    Summary = 'About Product',
    Bundles = 'Bundles',
    Tabs = 'Product Details',
    UpSelling = 'Accessories',
    CrossSelling = 'Related Products',
    RecentlyReviewed = 'Recently Viewed',
  }